"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabyrinthusBoard = void 0;
const SpaceBonus_1 = require("../SpaceBonus");
const Board_1 = require("./Board");
const BoardBuilder_1 = require("./BoardBuilder");
const constants_1 = require("../constants");
class LabyrinthusBoard extends Board_1.Board {
    static newInstance(_shuffle, rng, includeVenus, includePromo, erodedSpaces = []) {
        const builder = new BoardBuilder_1.BoardBuilder(includeVenus, includePromo);
        const bonuses = LabyrinthusBoard.generateRandomSpacesWithBonuses();
        const getRandomBonus = (bonuses) => bonuses.splice(Math.floor(Math.random() * bonuses.length), 1)[0];
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses));
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses)).ocean(...getRandomBonus(bonuses));
        builder.land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses)).land(...getRandomBonus(bonuses));
        builder.shuffle(rng);
        const spaces = builder.build(erodedSpaces);
        return new LabyrinthusBoard(spaces);
    }
    static deserialize(board, players) {
        return new LabyrinthusBoard(Board_1.Board.deserializeSpaces(board.spaces, players));
    }
    static generateRandomSpacesWithBonuses() {
        const allPossibleBonuses = [
            ...Array(44).fill(SpaceBonus_1.SpaceBonus.PLANT),
            ...Array(10).fill(SpaceBonus_1.SpaceBonus.HEAT),
            ...Array(16).fill(SpaceBonus_1.SpaceBonus.STEEL),
            ...Array(6).fill(SpaceBonus_1.SpaceBonus.TITANIUM),
            ...Array(8).fill(SpaceBonus_1.SpaceBonus.DRAW_CARD),
            ...Array(8).fill(SpaceBonus_1.SpaceBonus.POWER),
            ...Array(3).fill(SpaceBonus_1.SpaceBonus.ANIMAL),
            ...Array(3).fill(SpaceBonus_1.SpaceBonus.MICROBE),
            ...Array(1).fill(SpaceBonus_1.SpaceBonus.OCEAN),
            ...Array(1).fill(SpaceBonus_1.SpaceBonus.TEMPERATURE),
        ];
        const spaces = [LabyrinthusBoard.generateRandomSpaceBonuses(allPossibleBonuses, 3)];
        const spacesWithNoBonusesCount = Math.floor(Math.random() * (15 - 10 + 1) + 10);
        spaces.push(...Array(spacesWithNoBonusesCount).fill([]));
        const remainingSpacesCount = 61 - spacesWithNoBonusesCount - 1;
        const spacesWithTwoBonusesCount = Math.ceil(remainingSpacesCount / 2) + Math.floor(Math.random() * 2);
        const spacesWithOneBonusCount = remainingSpacesCount - spacesWithTwoBonusesCount;
        for (let i = 0; i < spacesWithTwoBonusesCount; i++) {
            spaces.push(LabyrinthusBoard.generateRandomSpaceBonuses(allPossibleBonuses, 2));
        }
        for (let i = 0; i < spacesWithOneBonusCount; i++) {
            spaces.push(LabyrinthusBoard.generateRandomSpaceBonuses(allPossibleBonuses, 1));
        }
        return spaces;
    }
    static generateRandomSpaceBonuses(remainingBonuses, bonusCount) {
        let bonuses = [];
        for (let i = 0; i < bonusCount; i++) {
            bonuses.push(LabyrinthusBoard.addRandomBonus(remainingBonuses));
            if (bonuses.includes(SpaceBonus_1.SpaceBonus.OCEAN) || bonuses.includes(SpaceBonus_1.SpaceBonus.TEMPERATURE)) {
                bonuses = bonuses.filter((spaceBonus) => [SpaceBonus_1.SpaceBonus.OCEAN, SpaceBonus_1.SpaceBonus.TEMPERATURE].includes(spaceBonus));
                break;
            }
        }
        return bonuses;
    }
    static addRandomBonus(remainingBonuses) {
        return remainingBonuses.splice(Math.floor(Math.random() * remainingBonuses.length), 1)[0];
    }
    filterBonusOceanSpots(player, spaces) {
        if (player.name === 'neutral')
            return spaces;
        return player.canAfford(constants_1.HELLAS_BONUS_OCEAN_COST) ? spaces : spaces.filter((space) => space.bonus.includes(SpaceBonus_1.SpaceBonus.OCEAN) === false);
    }
    filterBonusTemperatureSpots(player, spaces) {
        if (player.name === 'neutral')
            return spaces;
        return player.canAfford(constants_1.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST) ? spaces : spaces.filter((space) => space.bonus.includes(SpaceBonus_1.SpaceBonus.TEMPERATURE) === false);
    }
    getSpaces(spaceType, player) {
        let spaces = this.filterBonusOceanSpots(player, super.getSpaces(spaceType, player));
        return this.filterBonusTemperatureSpots(player, spaces);
    }
    getAvailableSpacesForCity(player) {
        let spaces = this.filterBonusOceanSpots(player, super.getAvailableSpacesForCity(player));
        return this.filterBonusTemperatureSpots(player, spaces);
    }
    getAvailableSpacesOnLand(player) {
        let spaces = this.filterBonusOceanSpots(player, super.getAvailableSpacesOnLand(player));
        return this.filterBonusTemperatureSpots(player, spaces);
    }
    getAvailableSpacesForGreenery(player) {
        let spaces = this.filterBonusOceanSpots(player, super.getAvailableSpacesForGreenery(player));
        return this.filterBonusTemperatureSpots(player, spaces);
    }
    getVolcanicSpaceIds() {
        return [];
    }
    getNoctisCitySpaceIds() {
        return [];
    }
}
exports.LabyrinthusBoard = LabyrinthusBoard;
//# sourceMappingURL=LabyrinthusBoard.js.map